import { FC, useEffect, useState } from "react";
import { Checkbox, Stack } from "@mui/material";
import { TrackingOptionModel } from "../Tracking";
interface TrackingOptionProps {
    option: TrackingOptionModel;
}

const TrackingOption: FC<TrackingOptionProps> = ({ option }) => {
    const [selected, setSelected] = useState<boolean>(false);

    useEffect(() => {
        if (option.selected !== undefined)
            setSelected(option.selected);
    }, [option])

    function Selected(e: any) {
        var value = e.target.checked;
        option.selected = value;
        setSelected(value);
    }

    return (
        <Stack direction={"row"}
            alignItems={"center"}>
            <Checkbox
                checked={selected}
                onChange={Selected}
                inputProps={{ 'aria-label': 'controlled' }} />

            {option.name}
        </Stack>
    )
}

export default TrackingOption;